import { Link } from "react-router-dom";
import { Boxes, Twitter, Linkedin, Instagram, Youtube, ArrowUpRight } from "lucide-react";
import { NAV_LINKS, LOGIN_URL, REGISTER_URL, CONTACT_INFO } from "../data/site";

const socialIcons = { Twitter, LinkedIn: Linkedin, Instagram, YouTube: Youtube };

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="relative z-10 border-t border-white/10 bg-ink">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        {/* Top */}
        <div className="grid grid-cols-2 gap-10 py-16 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-brand text-white">
                <Boxes className="h-5 w-5" />
              </span>
              <span className="font-heading text-lg font-semibold text-white">
                Activity<span className="text-brand">Hub</span> Manager
              </span>
            </Link>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-zinc-400">
              The cloud platform helping activity institutes simplify daily operations,
              save time, and improve student management.
            </p>
            <div className="mt-6 flex gap-3" data-testid="footer-socials">
              {Object.entries(socialIcons).map(([name, Icon]) => (
                <a
                  key={name}
                  href="#"
                  aria-label={name}
                  data-testid={`social-${name.toLowerCase()}`}
                  className="flex h-10 w-10 items-center justify-center rounded-md border border-white/10 text-zinc-400 transition-colors hover:border-brand hover:text-white"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">Product</h4>
            <ul className="mt-5 space-y-3 text-sm">
              {NAV_LINKS.slice(1, 5).map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-zinc-400 transition-colors hover:text-white">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">Company</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/about" className="text-zinc-400 transition-colors hover:text-white">About</Link></li>
              <li><Link to="/contact" className="text-zinc-400 transition-colors hover:text-white">Contact</Link></li>
              <li><Link to="/privacy" className="text-zinc-400 transition-colors hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-zinc-400 transition-colors hover:text-white">Terms &amp; Conditions</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">Get Started</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href={REGISTER_URL} className="inline-flex items-center gap-1 text-zinc-400 transition-colors hover:text-white">Register <ArrowUpRight className="h-3.5 w-3.5" /></a></li>
              <li><a href={LOGIN_URL} className="inline-flex items-center gap-1 text-zinc-400 transition-colors hover:text-white">Login <ArrowUpRight className="h-3.5 w-3.5" /></a></li>
              <li><a href={`mailto:${CONTACT_INFO.email}`} className="text-zinc-400 transition-colors hover:text-white">{CONTACT_INFO.email}</a></li>
            </ul>
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="select-none overflow-hidden border-t border-white/10 py-8">
          <h2 className="font-heading text-[13vw] font-black leading-none tracking-tighter text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.08)]">
            ACTIVITY HUB
          </h2>
        </div>

        {/* Bottom */}
        <div className="flex flex-col items-start justify-between gap-3 border-t border-white/10 py-6 text-sm text-zinc-500 md:flex-row md:items-center">
          <p data-testid="footer-copyright">© {year} Activity Hub Manager. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/contact" className="hover:text-white">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
